import ProgressBar from "./ProgressBar";
import progressbar_reducer, { setProgressBar, cleanupProgressBar } from "./slice";

export { progressbar_reducer, setProgressBar, cleanupProgressBar };
export default ProgressBar;
